import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification, selectCurrentLanguage } from '../../../features/auth/authSlice';
import { useMarkNotificationReadMutation } from '../../../features/user/userApiSlice';
import { getCategoriesTranslations } from '../../../utils/firebase.config';

const NotificationListItem = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const lang = useSelector(selectCurrentLanguage);
    const [markRead] = useMarkNotificationReadMutation();
    const [categoryTranslations, setCategoryTranslations] = useState(null);
    const { id, clientName, masterName, jobTitle, title, description: notificationLocation, jobFK, type, proposedPayment, currency, executionTime, minPayment, maxPayment, lat, lng, isSmall } = props;
    const isCandidate = type === 'master_applied';
    const isNewJob = type === 'job_created';
    const isCompletion = type === 'job_completed';
    const [localizedLocation, setLocalizedLocation] = useState(notificationLocation);
    const categoryIndex = categoryTranslations?.input?.indexOf(jobTitle);
    const localizedJobTitle = categoryTranslations?.translated?.[categoryIndex]?.[lang] || jobTitle;
    const notificationUrl = isCandidate
        ? `/client-office/manage-jobs/manage-candidates?id=${jobFK}`
        : `/master-office/job/${encodeURIComponent(jobTitle || 'job')}/${jobFK}`;

    const onOpen = async () => {
        await markRead(id).unwrap();
        dispatch(removeNotification(id));
    };

    useEffect(() => {
        let isMounted = true;
        getCategoriesTranslations()
            .then(translations => isMounted && setCategoryTranslations(translations))
            .catch(error => console.error('Category translations could not be loaded:', error));
        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        setLocalizedLocation(notificationLocation);
        if (!isNewJob || !Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return undefined;

        let isMounted = true;
        const localizeAddress = () => {
            if (!window.google?.maps?.Geocoder) return;
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: { lat: Number(lat), lng: Number(lng) } }, (results, status) => {
                if (isMounted && status === 'OK' && results?.[0]?.formatted_address) {
                    setLocalizedLocation(results[0].formatted_address);
                }
            });
        };

        localizeAddress();
        window.addEventListener('help2fix:maps-loaded', localizeAddress);
        return () => {
            isMounted = false;
            window.removeEventListener('help2fix:maps-loaded', localizeAddress);
        };
    }, [isNewJob, lang, lat, lng, notificationLocation]);

    return <li className="notifications-not-read">
        <NavLink onClick={onOpen} to={notificationUrl} state={{ id: jobFK, name: jobTitle, page: isCandidate ? 'ManageCandidates' : 'Job' }}>
            <span className="notification-icon"><i className="icon-material-outline-group"></i></span>
            <span className="notification-text">
                {isCandidate ? <>
                    <strong>{masterName}</strong> {t(title)} <span className="color">{localizedJobTitle}</span>
                    <span> · {proposedPayment} {currency}{executionTime ? ` · ${executionTime}` : ''}</span>
                </> : isNewJob ? <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{localizedJobTitle}</span>
                    {localizedLocation && <span> · {localizedLocation}</span>}
                    <span> · {minPayment}–{maxPayment} {currency}</span>
                </> : isCompletion ? <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{localizedJobTitle}</span>
                    <span> · {'★'.repeat(Number(props.rating || props.description || 0))}</span>
                </> : <>
                    <strong>{clientName}</strong> {t(title)} <span className="color">{localizedJobTitle}</span>
                </>}
            </span>
            {!isSmall &&
            <div className="buttons-to-right">
                <a href="#" className="button ripple-effect ico" title="Mark as read" data-tippy-placement="left"><i className="icon-feather-check-square"></i></a>
            </div>}
        </NavLink>
    </li>;
};

export default NotificationListItem;
